module.exports = __webpack_public_path__ + "static/media/horn.dcccfa2c.ogg";